import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Row,
  Label,
  Button,
} from "reactstrap";
import toast from "react-hot-toast";
import PrintHeader from "../../Components/PrintHeader/PrintHeader";
import SalesServices from "../../Services/SalesServices/SalesServices";
import PrintView from "./Components/PrintView";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DashBoardView from "./Components/DashBoardView";

const SalesReport = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPaymentCount, setTotalPaymentCount] = useState(0);
  const [totalPaymentAmount, setTotalPaymentAmount] = useState(0);
  const [topItems, setTopItems] = useState([]);
  const [topExpCategory, setTopExpCategory] = useState([]);

  const getInitialDateRange = () => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    return {
      fromDate: startDate.toISOString().split("T")[0],
      toDate: endDate.toISOString().split("T")[0],
    };
  };

  const [fromDate, setFromDate] = useState(getInitialDateRange().fromDate);
  const [toDate, setToDate] = useState(getInitialDateRange().toDate);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await SalesServices.getList({
        startDate: fromDate,
        endDate: toDate,
      });

      const transformedData = [
        { type: "Cash Payment", amount: response.cashPaymentAmount, count: response.cashPaymentCount },
        { type: "Bank Payment", amount: response.bankPaymentAmount, count: response.bankPaymentCount },
        { type: "Card Payment", amount: response.cardPaymentAmount, count: response.cardPaymentCount },
        { type: "Online Payment", amount: response.onlinePaymentAmount, count: response.onlinePaymentCount },
        { type: "Expenses", amount: response.totalExp, count: response.totalExpCount },
      ];

      setData(transformedData);
      setTotalPaymentCount(response.totalPaymentCount);
      setTotalPaymentAmount(response.totalPaymentAmount);
      setTopItems(response.topItems);
      setTopExpCategory(response.topExpCategory);
    } catch (error) {
      toast.error(error.response?.data || "Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate]);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Sales Report" pageTitle="Sales" />
        <PrintHeader reportTitle="Sales Report" />

        <Card>
          <CardHeader className="d-print-none">
            <Row className="g-3">
              <Col lg={3}>
                <Label>From Date</Label>
                <Input
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </Col>
              <Col lg={3}>
                <Label>To Date</Label>
                <Input
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </Col>
              {/* <Col className="d-flex justify-content-end align-items-center">
                <Button
                  color="outline-secondary"
                  className="py-1 px-2 shadow-sm"
                  onClick={handlePrint}
                >
                  <i className="ri-printer-line fs-16"></i>
                </Button>
              </Col> */}
            </Row>
          </CardHeader>
          <CardBody>
            <div className="d-print-none">
              <DashBoardView
                data={data}
                totalPaymentCount={totalPaymentCount}
                totalPaymentAmount={totalPaymentAmount}
                topItems={topItems}
                topExpCategory={topExpCategory}
              />
            </div>
            <PrintView
              data={data}
              totalPaymentCount={totalPaymentCount}
            />
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default SalesReport;
